export default value => {
    if (!value) {
        return
    }

    return Math.floor(value / 12) + "'" + value % 12 + '"'
}